import "clsx";
function _page($$renderer) {
  $$renderer.push(`<div class="stack center" style="padding: var(--vs-xl) var(--hpad); place-items: center"><img src="./Logo_physiodom.jpg" style="width: 148px" alt="Logo"/> <p>PHYSIO-DOMIZIL-ZÜRICH</p> <h5 class="pblue">Für Neurologie und Geriatrie</h5> <p>Monika Fischer</p> <p>dipl. Physiotherapeutin FH MSc Neurorehabilitation</p></div>`);
}
export {
  _page as default
};
